import Phaser from 'phaser';
import Board from './board';
import Sdk from './sdk';
import i18n from '../assets/i18n.json';
import debounce from './utils/debounce';

export default class Onboarding extends Phaser.GameObjects.Container {
    private board: Board;
    private resizeObserver?: ResizeObserver;
    private onFinish: () => void;

    constructor(scene: Phaser.Scene, board: Board, onFinish: () => void) {
        super(scene);
        this.board = board;
        this.onFinish = onFinish;
        scene.add.existing(this);
        const { width, height } = this.scene.renderer;

        this.start();
        this.setInteractive(new Phaser.Geom.Rectangle(width/2, height/2, 4*width, 4*height), Phaser.Geom.Rectangle.Contains);

        this.resizeObserver = new ResizeObserver(debounce(this.onResize.bind(this), 100));
        this.resizeObserver.observe(this.scene.game.canvas);
    }

    private start() {
        const { width, height } = this.scene.renderer;
        const texts = i18n[(this.scene.registry.get('sdk') as Sdk).getLang()];

        const backdrop = this.scene.add.rectangle(width/this.scale/2, height/this.scale/2, width/this.scale, height/this.scale, 0x000, 0.5)
            .setDepth(1)
            .setName('backdrop');
        const hand = this.scene.add.image(width/this.scale/this.scale/2, height/2, 'hand')
            .setScale(0.25)
            .setName('hand');

        this.startAnimation(hand);

        const text = this.scene.add.text(width/this.scale/2, height/this.scale/4, texts.onboarding, {
            fontSize: 56,
            color: '#FFF',
            fontFamily: 'Trebuchet MS'
        }).setOrigin(0.5).setName('text');
        this.add([backdrop, hand, text]);
    }

    private startAnimation(hand: Phaser.GameObjects.Image) {
        const { width, height } = this.scene.renderer;
        const texts = i18n[(this.scene.registry.get('sdk') as Sdk).getLang()];

        this.scene.add.tween({
            targets: hand,
            ease: 'Sine.easeInOut',
            scale: 0.2,
            duration: 1000
        });
        this.scene.add.tween({
            targets: hand,
            ease: 'Sine.easeInOut',
            x: '+='+(this.scene.renderer.width/this.scale/5),
            y: '+='+(this.scene.renderer.height/this.scale/5),
            duration: 2000,
            delay: 1000
        });
        this.scene.add.tween({
            targets: this.board.boardContainer,
            ease: 'Sine.easeInOut',
            y: '+='+(this.scene.renderer.height*this.scale/5),
            x: '+='+(this.scene.renderer.width*this.scale/5),
            duration: 2000,
            delay: 1000
        });
        this.scene.add.tween({
            targets: hand,
            ease: 'Sine.easeInOut',
            scale: 0.25,
            delay: 3000,
            duration: 1000
        });

        const nextStart = 4000;

        this.scene.add.tween({
            targets: hand,
            ease: 'Sine.easeInOut',
            scale: 0.2,
            duration: 1000,
            delay: nextStart
        });
        this.scene.add.tween({
            targets: hand,
            ease: 'Sine.easeInOut',
            x: '-='+(this.scene.renderer.width/this.scale/5),
            y: '-='+(this.scene.renderer.height/this.scale/5),
            duration: 2000,
            delay: nextStart + 1000
        });
        this.scene.add.tween({
            targets: this.board.boardContainer,
            ease: 'Sine.easeInOut',
            y: '-='+(this.scene.renderer.height/this.scale/5),
            x: '-='+(this.scene.renderer.width/this.scale/5),
            duration: 2000,
            delay: nextStart + 1000,
            onComplete: () => {
                const text = this.scene.add.text(width/this.scale/2, height/this.scale/4*3, texts.closeOnboarding, {
                    fontSize: 56,
                    color: '#FFF',
                    fontFamily: 'Trebuchet MS'
                }).setOrigin(0.5).setName('startText');
                this.add(text);
                this.enableCloseOnTap();
            }
        });
    }

    private enableCloseOnTap() {
        this.on('pointerdown', () => {
            this.onFinish();
            this.destroy();
            this.resizeObserver?.disconnect();
        });
    }

    private onResize() {
        if (this.scene.renderer.width < 700 || this.scene.renderer.height < 700) {
            this.setScale(0.5);
        } else {
            this.setScale(1);
        }

        const { width, height } = this.scene.renderer;

        this.setSize(width/this.scale, height/this.scale)
            .setPosition(0, 0);
        (this.getByName('backdrop') as Phaser.GameObjects.Rectangle)
            .setSize(width/this.scale, height/this.scale)
            .setPosition(width/this.scale/2, height/this.scale/2);
        const hand = (this.getByName('hand') as Phaser.GameObjects.Image);
        hand.setPosition(hand.x/this.scale, hand.y/this.scale);
        
        (this.getByName('text') as Phaser.GameObjects.Text)
            .setPosition(width/this.scale/2, height/this.scale/4);
        (this.getByName('startText') as Phaser.GameObjects.Text)
            ?.setPosition(width/this.scale/2, height/this.scale/4*3);

    }
}
